// Upstream copy is written with the "Chatwoot" brand name baked in. Rather than
// hardcoding a brand into the locale files, swap the configured installation
// (or brand) name into every translated string at runtime.
//
// Wire this into createI18n as `postTranslation` so white-labelled installs stay
// consistent everywhere, including strings added by future upstream copy.
export const buildInstallationNamePostTranslation =
  ({ preferBrandName = false } = {}) =>
  value => {
    const config = window.globalConfig || {};
    const name = preferBrandName
      ? config.BRAND_NAME || config.INSTALLATION_NAME
      : config.INSTALLATION_NAME;

    if (!name || name === 'Chatwoot') return value;
    if (typeof value !== 'string' || !value.includes('Chatwoot')) return value;

    return value.replaceAll('Chatwoot', name);
  };
